/** First-segment path under `/group/packages/:type/:businessId/...` for PingPad management content areas. */
export const contentPermissionToRoute: Record<string, string> = {
  EXTENSIONS: 'extensions',
  SERVICES: 'service-tags',
  BULLETIN_BOARD: 'bulletin-board',
  BUSINESS_BRANDING: 'design',
  APP_SETTINGS: 'customize-pingpad',
  CALL_LOGS: 'call-logs',
  ROLES: 'roles',
  ACCESS_CONTROL: 'access-control-policy',
};

/** Safe landing page for management users when no granted permission maps to a page (e.g. SUBSCRIPTION_ADMIN alone). */
export const DEFAULT_MANAGEMENT_ROUTE = 'roles';

export function getFirstPermittedContentRoute(contentPermissions?: string[]): string | undefined {
  const list = (contentPermissions ?? []).filter((c) => c !== 'SUBSCRIPTION_ADMIN');
  return list.map((c) => contentPermissionToRoute[c]).find(Boolean);
}
